// SafeZone unlock-token store.
//
// The token is a SIGNED server credential valid ~2 minutes; the server is the
// real gate (every SafeZone API call re-verifies it). We keep it in
// sessionStorage so an in-tab reload doesn't re-ask, while staying per-tab and
// vanishing when the browser closes. The expiry stored here is advisory (UX);
// the server enforces the real one.

const KEY = 'safezone_unlock';

export const SAFEZONE_LOCKED_EVENT = 'safezone:locked';

interface StoredUnlock {
  token: string;
  exp: number; // epoch ms
}

export function getUnlockToken(): string | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredUnlock;
    if (!parsed.token || parsed.exp <= Date.now()) {
      sessionStorage.removeItem(KEY);
      return null;
    }
    return parsed.token;
  } catch {
    return null;
  }
}

export function setUnlockToken(token: string, expiresInSeconds: number): void {
  const stored: StoredUnlock = { token, exp: Date.now() + expiresInSeconds * 1000 };
  sessionStorage.setItem(KEY, JSON.stringify(stored));
}

export function clearUnlockToken(): void {
  sessionStorage.removeItem(KEY);
}

// Fired (by the http layer) whenever the server rejects a SafeZone call with
// safezone_pin_locked — the gate listens and flips back to the lock screen.
export function announceLocked(): void {
  clearUnlockToken();
  window.dispatchEvent(new CustomEvent(SAFEZONE_LOCKED_EVENT));
}
